import React from "react";

import MessagesDataTable from "./MessagesDataTable";

const MessagesPage = () => {
  return (
    <div className="sub-content messages">
      <MessagesDataTable />
    </div>
  );
};

export default MessagesPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/follow-ups/messages/MessagesPage.js